import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getUser, getToken, getRefreshToken } from 'services/auth'

interface State {
  accessToken: string | null
  refreshToken: string | null
  expiration?: number
  email: string
  name: string
  id: string
  roles: string[]
  logo: string
  meta: {
    isLoading: boolean
    error: string | null
  }
}

interface LoginSuccessPayload {
  accessToken: string
  refreshToken: string
  exp: number
  user_email: string
  user_name: string
  user_id: string
  roles: string[]
  shipper_logo: string
}

const initialUser = () => {
  const { user_email, user_id, user_name, roles, shipper_logo } =
    getUser() || {}
  return {
    email: user_email || '',
    id: user_id,
    name: user_name || '',
    roles: roles || [],
    logo: shipper_logo || '',
  }
}

const initialState: State = {
  accessToken: getToken(),
  refreshToken: getRefreshToken(),
  meta: { isLoading: false, error: null },
  ...initialUser(),
}

export const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    loginStart(state) {
      state.meta.isLoading = true
      state.meta.error = null
    },
    loginSuccess(state, action: PayloadAction<LoginSuccessPayload>) {
      state.meta.isLoading = false
      state.accessToken = action.payload.accessToken
      state.refreshToken = action.payload.refreshToken
      state.expiration = action.payload.exp
      state.email = action.payload.user_email
      state.name = action.payload.user_name
      state.id = action.payload.user_id
      state.roles = action.payload.roles
      state.logo = action.payload.shipper_logo
    },
    loginFailed(state, action: PayloadAction<string>) {
      state.meta.isLoading = false
      state.meta.error = action.payload
    },
  },
})

export default slice.reducer
